const {
  ORDER_DISPLAY_STATUS,
  SHIPMENT_STATUS_TO_ORDER_DISPLAY_STATUS
} = require('../constants')

// Returns the user facing status key for an order.
const getOrderStatus = (order) => {
  const { shipmentStatus, closedStatus } = order
  const fallbackStatus = ORDER_DISPLAY_STATUS.IN_REVIEW

  if (closedStatus && closedStatus.toLowerCase() === ORDER_DISPLAY_STATUS.CANCELLED) {
    return ORDER_DISPLAY_STATUS.CANCELLED
  }

  if (!shipmentStatus) {
    return fallbackStatus
  }

  return SHIPMENT_STATUS_TO_ORDER_DISPLAY_STATUS[shipmentStatus] || fallbackStatus
}

module.exports = { getOrderStatus }
